import {
  Button,
  Divider,
  InlineGrid,
  Link,
  Text,
  ButtonGroup,
  Icon,
  InlineStack,
  TextField,
} from "@shopify/polaris";
import { ComposeIcon, ExternalIcon, RefreshIcon } from "@shopify/polaris-icons";
import React from "react";

const MerchantPromotions = ({ data }) => {
  return (
    <>
      {/* Merchant Promotions */}
      <InlineGrid columns={["oneThird", "twoThirds"]}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            rowGap: "15px",
            paddingLeft: "30px",
            paddingTop: "20px",
            paddingBottom: "20px",
            width: "25vw",
          }}
        >
          <Text variant="headingLg" fontWeight="semibold">
            Merchant Promotions
          </Text>
          <Text as="p">
            Promotion ID field will only include Promotion Ids which are created
            for Specific Products only. You can assign multiple Promotion Ids to
            same product
          </Text>
        </div>
        <div
          style={{ paddingTop: "20px", width: "50vw", paddingBottom: "20px" }}
        >
          <InlineGrid
            gap={100}
            columns={["oneThird", "twoThirds"]}
            alignItems="center"
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "end",
                width: "15vw",
              }}
            >
              <Text as="p">Promotion ID</Text>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "20vw",
              }}
            >
              <Text>
                Currently, no promotion has been created for Specific Products.
                New promotions can be created by clicking{" "}
                <Link removeUnderline url="https://google.com">
                  here
                </Link>
              </Text>
            </div>
          </InlineGrid>
        </div>
      </InlineGrid>
      <Divider />
    </>
  );
};

export default MerchantPromotions;
